/*
 *
 * SalesforceVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_SALESFORCE } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const salesforceVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_SALESFORCE.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_SALESFORCE.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_SALESFORCE.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default salesforceVerifyReducer;
